import {
  BSCol,
  BSGrid,
  Card,
  Spinner,
  Text,
  Title,
} from "@appquality/appquality-design-system";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { PageTemplate } from "src/features/PageTemplate";
import {
  useGetUsersMeBugsByBugIdCampaignIdQuery,
  useGetUsersMeCampaignsByCampaignIdQuery,
} from "../../services/tryberApi";
import BugDetail from "./BugDetail";
import BugList from "./BugList";
import BugShowFilters from "./BugShowFilters";
import { Search } from "./Search";
import { EmptyState, LoadingContainer } from "./styled";

export default function BugShow() {
  const { t } = useTranslation();
  const { bugId } = useParams<{
    bugId: string;
  }>();

  const {
    data: campaign,
    error: bugError,
    isLoading: isBugLoading,
  } = useGetUsersMeBugsByBugIdCampaignIdQuery(
    { bugId: bugId },
    { skip: !bugId },
  );

  const campaignId = campaign?.campaignId.toString();

  const { data: campaignData } = useGetUsersMeCampaignsByCampaignIdQuery(
    { campaignId: campaignId || "" },
    { skip: !campaignId },
  );

  const route = `bugs/show/${bugId}`;

  const currentBugId = bugId ? parseInt(bugId) : undefined;

  if (!bugId) {
    return (
      <PageTemplate title={t("Bug Review")} route={route} shouldBeLoggedIn>
        <EmptyState>
          <Text>{t("No bug selected")}</Text>
        </EmptyState>
      </PageTemplate>
    );
  }

  if (isBugLoading) {
    return (
      <PageTemplate title={t("Bug Review")} route={route} shouldBeLoggedIn>
        <LoadingContainer>
          <Spinner />
        </LoadingContainer>
      </PageTemplate>
    );
  }

  if (bugError || !campaign || !campaignId) {
    return (
      <PageTemplate title={t("Bug Show")} route={route} shouldBeLoggedIn>
        <EmptyState>
          <Text className="aq-text-danger">
            {t("Bug not found or you don't have access")}
          </Text>
        </EmptyState>
      </PageTemplate>
    );
  }

  return (
    <PageTemplate
      title={campaignData?.title || t("Bug Show")}
      route={route}
      subtitle={`CP${campaignId} ${
        campaignData?.hasBugParade ? t("- Bug Parade") : ""
      }`}
      shouldBeLoggedIn
    >
      <Search />
      <BugShowFilters campaignId={campaignId} />

      <BSGrid>
        <BSCol size="col-lg-4 aq-order-1 aq-order-0-lg">
          <Card className="stick-to-header-lg aq-mb-3" shadow>
            <Title size="s" className="aq-mb-3">
              {campaignData?.hasBugParade ? t("Bugs") : t("My bugs")}
            </Title>
            <BugList campaignId={campaignId} currentBugId={currentBugId} />
          </Card>
        </BSCol>

        <BSCol size="col-lg-8 aq-order-0 aq-order-1-lg">
          <BugDetail
            campaignId={campaignId}
            bugId={currentBugId}
            hasBugParade={campaignData?.hasBugParade || 0}
            minimumMedia={campaignData?.minimumMedia || 0}
            additionalFields={campaignData?.additionalFields}
            validFileExtensions={campaignData?.validFileExtensions}
          />
        </BSCol>
      </BSGrid>
    </PageTemplate>
  );
}
